import { colord } from 'colord';
export const RECENTS_KEY = 'status-color-recents';

export type ColorCodeFormat = 'hex' | 'rgb';

export type RGBColorCode = {
  red: number;
  green: number;
  blue: number;
};

export type RGBColorCodeKey = 'red' | 'green' | 'blue';

export enum Colors {
  RED = 'red',
  GREEN = 'green',
  BLUE = 'blue'
}

export enum ColorFormat {
  HEX = 'hex',
  RGB = 'rgb'
}
export const colorFormatOptions: {
  value: ColorFormat;
  text: string;
}[] = [
    {
      value: ColorFormat.HEX,
      text: 'HEX'
    },
    {
      value: ColorFormat.RGB,
      text: 'RGB'
    }
  ];
export const converToHex = (input: string, fmt: ColorCodeFormat): string | null => {
  const trimmedInput = (input || '').trim();
  if (!trimmedInput) return null;
  let hexColor: string | null = null;
  if (fmt === ColorFormat.HEX) {
    // Only allow 6 character hex codes, auto-append # if missing
    const hexPattern = /^#?[0-9a-fA-F]{6}$/;
    if (hexPattern.test(trimmedInput)) {
      const normalizedInput = trimmedInput.startsWith('#') ? trimmedInput : `#${trimmedInput}`;
      const color = colord(normalizedInput);
      hexColor = color.isValid() ? color.toHex() : null;
    }
  } else {
    const color = colord(trimmedInput);
    hexColor = color.isValid() ? color.toHex() : null;
  }
  return hexColor;
};

export const readRecentColors = (): string[] => {
  try {
    const raw = localStorage.getItem(RECENTS_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const updateRecentColors = (colors: string[]) => {
  try {
    localStorage.setItem(RECENTS_KEY, JSON.stringify(colors));
  } catch { }
};

export const getDistinctColors = (colors: string[], limit = 8) => {
  const distinctColors: string[] = [];
  for (const color of colors) {
    const hexColor = colord(color).toHex().toUpperCase();
    if (!distinctColors.includes(hexColor)) distinctColors.push(hexColor);
    if (distinctColors.length >= limit) break;
  }
  return distinctColors;
};
